export default __webpack_public_path__ + "static/media/Quicksand-VariableFont_wght.b964ff93.ttf";